export enum DiscountType {
    Amount = 0,
    Percentage = 1,
}
